// extracted by mini-css-extract-plugin
export default {"block":"register_block__DRyof","title":"register_title__7-Zu0","form":"register_form__W4Aqs","link":"register_link__TyBDl"};